import React from "react";
import styles from "../v2.module.css";

/**
 * Mise en page V2 historique. Les slots sont construits par HomeV2 : aucun accès
 * aux données, calcul, appel réseau ou état de don n'appartient à une variante.
 * Garder les wrappers, l'ordre DOM et la ref du don pour préserver le parcours.
 */
export default function StandardLayout({
    header, ambassadorSpace, teamBanner, banner, donation, story, sections,
    ambassadorSignup, footer, stickyBar, blockProps, donateRef,
}) {
    return <>
        {header}
        {ambassadorSpace}
        {teamBanner}
        <main className={styles.layout}>
            <div {...blockProps("banner", styles.bannerArea)}>{banner}</div>
            <div className={styles.donateArea} ref={donateRef}>
                <div className={styles.donateCard}>{donation}</div>
            </div>
            <div {...blockProps("story", styles.storyArea)}>{story}</div>
        </main>
        <div className={styles.contentBlocks}>{sections}</div>
        {ambassadorSignup}
        {footer}
        {stickyBar}
    </>
}
